/**
 * Created by Pawel Grzyb 01.04.2018
 *
 * The component shows next classes in the main banner .
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner-classes',
  templateUrl: './banner-classes.component.html',
  styleUrls: [ './banner-classes.component.css' ]
})
export class BannerClassesComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
